import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';

import { PROJECT_TYPES } from '../../constants';
import ResponseForm from '../../scout-collect-data/components/response-form/ResponseForm';
import Header from '../scout/components/header/Header';
import MessagesList from './components/messages-list/MessagesList';
import { requestForHelpConsumer, sendResponseDataConsumer } from '../../redux/consumer/scout/consumerScoutActions';

import scss from '../scout/Scout.module.scss';

function ScoutCollectData() {
  const [isShowResponseForm, setIsShowResponseForm] = useState(true);
  const { projectName } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const storedProjectName = useSelector((state) => state.consumer.scout.projectName);
  const storedProjectPassword = useSelector((state) => state.consumer.scout.projectPassword);

  const toggleResponseFormVisibility = () => {
    setIsShowResponseForm((prevState) => !prevState);
  };

  const handleSendResponse = async (values) => {
    await dispatch(sendResponseDataConsumer(values));
    navigate(`/${PROJECT_TYPES.SCOUTV2.toLocaleLowerCase()}/${projectName}`);
  };

  const handleRequestForHelp = async (values) => {
    await dispatch(requestForHelpConsumer(values));
    navigate(`/${PROJECT_TYPES.SCOUTV2.toLocaleLowerCase()}/${projectName}`);
  };

  useEffect(() => {
    if (!storedProjectName || !storedProjectPassword) {
      navigate(`/${PROJECT_TYPES.SCOUTV2.toLocaleLowerCase()}/${projectName}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={scss.background}>
      <div className={scss.pageLayout}>
        <Header />
        <main className={scss.main}>
          <ResponseForm
            isShowResponseForm={isShowResponseForm}
            toggleResponseFormVisibility={toggleResponseFormVisibility}
            onSendResponse={handleSendResponse}
            onClickForHelp={handleRequestForHelp}
          />

          <MessagesList isShowResponseForm={isShowResponseForm} />
        </main>
      </div>
    </div>
  );
}

export default ScoutCollectData;
